import { Component } from '@theme/component';

/**
 * Inline variant selection for the Shop the Look panel.
 *
 * Wraps one native <select> per product option. On change it resolves the
 * matching variant from embedded JSON and updates the sibling
 * `<input name="id">` (read by product-form-component on submit), the price
 * label, and the add-to-cart button availability — no Section Rendering needed.
 *
 * @extends Component
 */
export default class AwVariantSelect extends Component {
  /** @type {Array<{id: number, o: string[], a: boolean, p: string}>} */
  #variants = [];

  connectedCallback() {
    super.connectedCallback();

    const data = this.querySelector('script.aw-variant-data');
    try {
      this.#variants = JSON.parse(data?.textContent || '[]');
    } catch {
      this.#variants = [];
    }

    this.addEventListener('change', this.#update);
    this.#update();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('change', this.#update);
  }

  /** @returns {HTMLSelectElement[]} */
  get #selects() {
    return /** @type {HTMLSelectElement[]} */ (Array.from(this.querySelectorAll('select')));
  }

  #update = () => {
    const selected = this.#selects.map((select) => select.value);
    const variant = this.#variants.find(
      (candidate) => candidate.o.length === selected.length && candidate.o.every((value, index) => value === selected[index])
    );

    const form = this.closest('product-form-component');
    const item = this.closest('.aw-stl__item');
    const idInput = /** @type {HTMLInputElement | null} */ (form?.querySelector('input[name="id"]'));
    const button = /** @type {HTMLButtonElement | null} */ (form?.querySelector('[ref="addToCartButton"]'));
    const priceEl = item?.querySelector('[data-aw-price]');
    const imageEl = /** @type {HTMLImageElement | null} */ (item?.querySelector('.aw-stl__item-image'));

    const available = Boolean(variant?.a);

    if (idInput && variant) idInput.value = String(variant.id);
    if (button) button.disabled = !available;
    if (priceEl && variant) priceEl.textContent = variant.p;

    // Affiche la photo de la variante sélectionnée (si elle en a une).
    if (imageEl && variant?.img) {
      imageEl.removeAttribute('srcset');
      imageEl.src = variant.img;
    }

    this.toggleAttribute('data-unavailable', !available);
  };
}

if (!customElements.get('aw-variant-select')) {
  customElements.define('aw-variant-select', AwVariantSelect);
}
